import stl from "./RemoveFiltersNote.module.css";
import useHelpers from "@hooks/useHelpers";
import {useTranslation} from "@i18n";

const RemoveFiltersNote = () => {
  const {navigateTo} = useHelpers();
  const {t} = useTranslation();

  return (
    <div className={stl.noteContainer}>
      <p>
        <strong>{t("حاول تعديل بعض الفلاتر", { ns: "web_search" })}</strong>{" "}
        <span>{t("لإيجاد نتائج بحث مطابقة", { ns: "web_search" })}</span>
      </p>
      <button
        onClick={() => {
          navigateTo("/filters");
        }}
      >
        {t("إعادة تعيين جميع الفلاتر", { ns: "web_search" })}
      </button>
    </div>
  );
};

export default RemoveFiltersNote;
